import { useCustom } from '@refinedev/core';
import { Badge, Card, Col, Row, Space, Statistic, Typography } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import type { LiveActivityStatsOut } from '@/api/generated/schemas';
import { formatLedger } from '@/utils/money';
import { formatDuration } from '@/utils/duration';

export const SettlementLiveBar = () => {
  const { query } = useCustom<LiveActivityStatsOut>({
    url: 'settlement/charges_monthly/stats/live',
    method: 'get',
    queryOptions: { refetchInterval: 30_000 },
  });

  const live = query.data?.data;

  return (
    <Card
      loading={query.isLoading}
      title={
        <Space>
          <Badge status="processing" />
          Na żywo
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            (odświeżanie co 30s)
          </Typography.Text>
        </Space>
      }
    >
      <Row gutter={[24, 16]}>
        <Col xs={12} sm={6}>
          <Statistic
            title="Naliczenia / 5 min"
            value={live?.charge_count ?? 0}
            prefix={<ThunderboltOutlined />}
            valueStyle={{ color: '#1677ff' }}
          />
        </Col>
        <Col xs={12} sm={6}>
          <Statistic
            title="Aktywni wydawcy"
            value={live?.active_publishers ?? 0}
          />
        </Col>
        <Col xs={12} sm={6}>
          <Statistic
            title="Czas odsłuchu dziś"
            value={live?.basis_seconds ?? 0}
            formatter={(val) => formatDuration(Number(val))}
          />
        </Col>
        <Col xs={12} sm={6}>
          <Statistic
            title="Należność dziś"
            value={live?.amount ?? '0'}
            formatter={(val) => formatLedger(val)}
          />
        </Col>
      </Row>
    </Card>
  );
};
